<script lang="ts">
  import emblaCarouselSvelte from 'embla-carousel-svelte';
  import type { EmblaOptionsType } from 'embla-carousel';
  import LocationCard from '$components/locations/+card.svelte';
  import CampaignCard from '$components/+campaignCard.svelte';
  import { init } from '$utils/embaCarousel'; // Assuming init is correctly typed
  import type { ComputedSectionItem, SectionsData } from '$types';

  // --- Props ---

  export let sections: SectionsData = {
    data: [],
  };

  export let carouselActive: boolean = true;

  export let carouselDots: boolean = true;

  // --- State ---

  let options: EmblaOptionsType = {
    loop: true,
    align: 'start',
    slidesToScroll: 1,
  };

  // --- Derived State ---

  let computedSections: ComputedSectionItem[] | undefined = sections?.data?.map((section) => {
    const campaignCount = section.campaigns?.length ?? 0;

    const isFeaturedWithMultipleItems = section.template === 'featured' && campaignCount > 2;
    const isLargeTemplate = section.template === 'large' && campaignCount > 1;
    const isCampaignLargeOrFeatured = section.type === 'campaign' && (isLargeTemplate || isFeaturedWithMultipleItems);

    return {
      ...section,
      isFeaturedWithMultipleItems,
      isLargeTemplate,
      isCampaignLargeOrFeatured,
      shouldShowControls: carouselActive && (section.type === 'location' || isCampaignLargeOrFeatured),
      shouldShowDots: (section.template === 'large' && carouselDots) || isFeaturedWithMultipleItems,
    };
  });
</script>

{#if computedSections}
  {#each computedSections as section}
    <section class="section-{section.type}s type-{section.type} section-{section.template}">
      {#if section.template !== 'featured' && section.name}
        <h2>{section.name}</h2>
      {:else if section.template === 'related'}
        <h2>Andre kigger også på</h2>
      {/if}

      <div class="sections embla" use:emblaCarouselSvelte={{ options, plugins: [] }} on:emblaInit={init}>
        <div class="embla__container">
          {#if section.type === 'campaign' && section.campaigns}
            {#each section.campaigns as item}
              <CampaignCard {item} template={section.template} href={`/campaign/${item.slug}`} />
            {/each}
          {:else if section.type === 'location' && section.locations}
            {#each section.locations as item}
              <LocationCard {item} href="?location-uuid={item.uuid}" />
            {/each}
          {/if}
        </div>

        {#if section.shouldShowControls}
          <div class="controls">
            {#if section.link && section.link_text}
              <a href={section.link} class="label">{section.link_text}</a>
            {/if}
            <button class="embla__prev">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" color="currentColor" class="shrink-0 h-6 w-6" role="img" aria-label="angle left outline" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m15 19-7-7 7-7"></path>
              </svg>
            </button>
            <button class="embla__next">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" color="currentColor" class="shrink-0 h-6 w-6" role="img" aria-label="angle right outline" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m9 5 7 7-7 7"></path>
              </svg>
            </button>
          </div>

          {#if section.shouldShowDots}
            <div class="control-dots">
              <div class="embla__dots"></div>
            </div>
          {/if}
        {/if}
      </div>
    </section>
  {/each}
{/if}
